export default __webpack_public_path__ + "static/media/edit.7b7dbf6c.svg";